"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentRoleEntityType = exports.AssignmentRoleType = exports.AccountUserStatusReason = exports.AccountUserStatus = exports.AccountUserRole = void 0;
var AccountUserRole;
(function (AccountUserRole) {
    AccountUserRole["CLAIM_EDITOR"] = "CLAIM_EDITOR";
    AccountUserRole["CLAIM_VIEWER"] = "CLAIM_VIEWER";
    AccountUserRole["CLIENT_USER"] = "CLIENT_USER";
    AccountUserRole["CLIENT_USER_ADMIN"] = "CLIENT_USER_ADMIN";
})(AccountUserRole = exports.AccountUserRole || (exports.AccountUserRole = {}));
var AccountUserStatus;
(function (AccountUserStatus) {
    AccountUserStatus["ACTIVE"] = "ACTIVE";
    AccountUserStatus["INACTIVE"] = "INACTIVE";
})(AccountUserStatus = exports.AccountUserStatus || (exports.AccountUserStatus = {}));
var AccountUserStatusReason;
(function (AccountUserStatusReason) {
    AccountUserStatusReason["ACTIVE"] = "ACTIVE";
    AccountUserStatusReason["INVITATION_PENDING"] = "INVITATION_PENDING";
    AccountUserStatusReason["REMOVED"] = "REMOVED";
    AccountUserStatusReason["REMOVED_ADDED_BY_MISTAKE"] = "REMOVED_ADDED_BY_MISTAKE";
    AccountUserStatusReason["REMOVED_LEFT_COMPANY_NOT_TO_BE_REPLACED"] = "REMOVED_LEFT_COMPANY_NOT_TO_BE_REPLACED";
    AccountUserStatusReason["REMOVED_LEFT_COMPANY_TO_BE_REPLACED"] = "REMOVED_LEFT_COMPANY_TO_BE_REPLACED";
    AccountUserStatusReason["REMOVED_ROLE_CHANGED"] = "REMOVE_ROLE_CHANGED";
})(AccountUserStatusReason = exports.AccountUserStatusReason || (exports.AccountUserStatusReason = {}));
var AssignmentRoleType;
(function (AssignmentRoleType) {
    AssignmentRoleType["CLIENT"] = "CLIENT";
})(AssignmentRoleType = exports.AssignmentRoleType || (exports.AssignmentRoleType = {}));
var AssignmentRoleEntityType;
(function (AssignmentRoleEntityType) {
    AssignmentRoleEntityType["CLAIM"] = "CLAIM";
    AssignmentRoleEntityType["INTERNAL"] = "INTERNAL";
})(AssignmentRoleEntityType = exports.AssignmentRoleEntityType || (exports.AssignmentRoleEntityType = {}));
//# sourceMappingURL=account-user.js.map